import { LayoutServiceData, RouteData } from "@sitecore-jss/sitecore-jss-react";

export function prepContext(routeData: LayoutServiceData) {
  return {
    route: routeData.sitecore.route as RouteData,
    itemId: routeData?.sitecore?.route?.itemId,
    ...routeData.sitecore.context,
  }
}
